import { Icon } from '@rbilabs/universal-components';
import { StatusBar } from 'expo-status-bar';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { useIsDesktopWebBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';
import { WEB_APP_MAX_WIDTH_DESKTOP_LARGE } from 'utils/constants';

export const NoNetworkHeader = () => {
  const isDesktopWebBreakpoint = useIsDesktopWebBreakpoint();

  return (
    <>
      <StatusBar backgroundColor={NO_NETWORK_BACKGROUND_COLOR} />
      <Box style={styles.container}>
        <Box style={[styles.content, isDesktopWebBreakpoint && styles.desktopContent]}>
          <Icon variant="warning" width="14px" marginRight={1} />
          <Typography variant="copyTwo" style={styles.text}>
            {t('noInternetConnection')}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export const NO_NETWORK_BACKGROUND_COLOR = '#FBE8E7';

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: NO_NETWORK_BACKGROUND_COLOR,
  },
  content: {
    alignItems: 'center',
    flexDirection: 'row',
    marginLeft: spacing.$10,
    maxWidth: WEB_APP_MAX_WIDTH_DESKTOP_LARGE,
    width: '100%',
  },
  desktopContent: {
    marginLeft: 0,
  },
  text: {
    lineHeight: 14,
  },
});
